import React, { Component } from 'react';
import { Icon, Drawer } from 'antd';

import * as globals from '../globals';
import logo from '../img/whitemapperlogo.png';

// import '../style/Header.scss';
// import logo from '../static/img/whitemapperlogo.png';

class App extends Component {
  state = { visible: false };

  showDrawer = () => {
    this.setState({
      visible: true,
    });
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  render() {
    const links = (
      <div className="row">
        <p>
          <a href="https://dpcfrontier.com/">DPC Frontier</a>
        </p>
        <div className="right">
          <a href="https://dpcnation.org">What Is DPC?</a>
        </div>
        <p>
          <a href="https://dpcfrontier.com/blog/">Blog</a>
        </p>
        <p>
          <a href="https://mapper.dpcfrontier.com/">Mapper</a>
        </p>
      </div>
    );

    return (
      <div className="row Header">
        <a href={globals.mapperURL} className="clickable">
          <img className="logo" src={logo} alt="DPC Frontier Mapper Logo" />
        </a>
        <div className="spacer" />
        <div className="showlarge showxlarge">{links}</div>
        <Icon
          style={{ color: 'white', fontSize: '28px' }}
          type="menu"
          theme="outlined"
          className="showsmall showmedium"
          onClick={this.showDrawer}
        />
        <Drawer
          title="DPC Frontier Menu"
          placement="right"
          closable={true}
          onClose={this.onClose}
          visible={this.state.visible}
        >
          {links}
        </Drawer>
      </div>
    );
  }
}

export default App;
